import { render, staticRenderFns } from "./VerifyOTP.vue?vue&type=template&id=4c3fd574&"
import script from "./VerifyOTP.vue?vue&type=script&lang=js&"
export * from "./VerifyOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports